import React from "react";

const TrialistIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1080 1080"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={562.16}
          y1={274.12}
          x2={531.69}
          y2={661.24}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.11} stopColor="#5cb0ea" />
          <stop offset={0.8} stopColor="#519acc" />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={416.15}
          y1={260.45}
          x2={360.66}
          y2={965.42}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={549.75}
          y1={270.48}
          x2={493.93}
          y2={979.68}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={538.49}
          y1={345.78}
          x2={539.78}
          y2={532.95}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#4fc0ff" />
          <stop offset={0.25} stopColor="#4fbdfc" />
          <stop offset={0.73} stopColor="#4583ad" />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={543.62}
          y1={457.91}
          x2={545.21}
          y2={561.38}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#52525e" />
          <stop offset={1} stopColor="#5d5e6b" />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={543.87}
          y1={334.84}
          x2={543.87}
          y2={334.76}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#5db1eb" />
          <stop offset={0.77} stopColor="#5dbcfc" />
        </linearGradient>
        <style>
          {
            ".prefix__cls-1{fill:#edcc43}.prefix__cls-19{fill:#519acc}.prefix__cls-3{fill:#fff}.prefix__cls-5{fill:#d1b542}.prefix__cls-11{fill:#ffd99c}.prefix__cls-12{fill:#64c3f9}.prefix__cls-14{fill:#5c5d68}.prefix__cls-18{fill:#43444c}"
          }
        </style>
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <circle className="prefix__cls-1" cx={540} cy={546.97} r={418.69} />
        <circle
          cx={540}
          cy={546.97}
          r={380.15}
          strokeWidth={15}
          stroke="#fff"
          strokeMiterlimit={10}
          fill="#519acc"
        />
        <path
          className="prefix__cls-3"
          d="M630.15 828.36l5.85 11.85 13.07 1.9-9.46 9.22 2.24 13.03-11.7-6.15-11.7 6.15 2.24-13.03-9.46-9.22 13.07-1.9 5.85-11.85zM848.47 562.26l4.02 8.13 8.97 1.31-6.49 6.33 1.53 8.94-8.03-4.22-8.03 4.22 1.54-8.94-6.5-6.33 8.98-1.31 4.01-8.13zM836.86 392.88l5.85 11.84 13.07 1.9-9.46 9.23 2.23 13.02-11.69-6.15-11.7 6.15 2.24-13.02-9.47-9.23 13.08-1.9 5.85-11.84zM695.18 234.78l4.02 8.13 8.97 1.31-6.5 6.32 1.54 8.94-8.03-4.22-8.03 4.22 1.54-8.94-6.5-6.32 8.98-1.31 4.01-8.13zM225.83 562.26l-4.01 8.13-8.98 1.31 6.5 6.33-1.54 8.94 8.03-4.22 8.03 4.22-1.54-8.94 6.5-6.33-8.98-1.31-4.01-8.13zM237.44 392.88l-5.84 11.84-13.08 1.9 9.46 9.23-2.23 13.02 11.69-6.15 11.7 6.15-2.23-13.02 9.46-9.23-13.08-1.9-5.85-11.84zM379.12 234.78l-4.01 8.13-8.98 1.31 6.5 6.32-1.54 8.94 8.03-4.22 8.03 4.22-1.53-8.94 6.49-6.32-8.98-1.31-4.01-8.13zM537.97 188.49l5.85 11.85 13.07 1.9-9.46 9.22 2.23 13.02-11.69-6.14-11.7 6.14 2.24-13.02-9.47-9.22 13.08-1.9 5.85-11.85zM446.84 828.36l5.85 11.85 13.08 1.9-9.46 9.22 2.23 13.03-11.7-6.15-11.69 6.15 2.23-13.03-9.46-9.22 13.08-1.9 5.84-11.85z"
        />
        <circle className="prefix__cls-1" cx={537.97} cy={852.69} r={41.28} />
        <circle
          cx={537.97}
          cy={852.69}
          r={41.28}
          fill="none"
          strokeWidth={3}
          stroke="#fff"
          strokeMiterlimit={10}
        />
        <path
          className="prefix__cls-3"
          d="M558.85 832.34a9.64 9.64 0 00-5.38.55v-2.84h-31v2.84a9.69 9.69 0 00-5.39-.55 6 6 0 00-4.7 4.75c-.74 3.29.9 7.07 4.63 10.63a31 31 0 0011.06 6.58 15.84 15.84 0 006.74 5.59c-.41 1.5-1.84 5.82-5.31 8.47h16.94c-3.47-2.65-4.91-7-5.31-8.47a15.84 15.84 0 006.74-5.59 30.93 30.93 0 0011-6.58c3.73-3.56 5.38-7.34 4.63-10.63a6 6 0 00-4.65-4.75zm-39.35 12.78c-2.7-2.58-4-5.28-3.61-7.23a2.42 2.42 0 012-2 7 7 0 014.81 1.11 43.29 43.29 0 002.68 12.26 25.59 25.59 0 01-5.88-4.14zm36.94 0a25.65 25.65 0 01-5.86 4.1 43.31 43.31 0 002.69-12.22 7 7 0 014.81-1.11 2.41 2.41 0 012 2c.4 1.95-.95 4.65-3.64 7.23zM527.09 870.63h21.75v4.7h-21.75z"
        />
        <path
          className="prefix__cls-5"
          d="M304.47 729.91l-25.57 5.46 19.11 29.05-11.41 49.54 37.23-5.46 5.96-.5-3.97-78.09h-21.35zM771.03 729.91l27.06 5.46-20.6 29.05 11.42 49.54-37.24-5.46-5.96-.5 3.98-78.09h21.34z"
        />
        <path
          className="prefix__cls-5"
          d="M769 805.32a1477.23 1477.23 0 00-462.09.74q-.68-42.78-.65-85.61a1561.29 1561.29 0 01462.94-.05q.29 42.5-.2 84.92z"
        />
        <circle cx={538.45} cy={497.97} r={256.65} fill="#4281a5" />
        <path
          className="prefix__cls-1"
          d="M769 801.68a1476.93 1476.93 0 00-462.09.74q-.68-42.78-.65-85.61a1561.29 1561.29 0 01462.94 0q.27 42.45-.2 84.87z"
        />
        <path
          className="prefix__cls-5"
          d="M419 729.17a.81.81 0 011 .72l.12 9.05a1.08 1.08 0 01-.93.95q-4.79.57-9.55 1.2 1.92 14.56 3.83 29.13a.87.87 0 01-.76.93q-5.49.74-11 1.51a.93.93 0 01-1-.68q-2.12-14.55-4.24-29.08-5.31.76-10.6 1.6a.91.91 0 01-1-.68l-1.48-8.82a.94.94 0 01.77-1q17.36-2.74 34.84-4.83zM468.73 764.55c.35.51-.06 1-.62 1q-6.69.48-13.36 1.05a1.64 1.64 0 01-1.51-.82q-3.81-6.15-7.71-12.27l-.76.07 1.24 13a1 1 0 01-.92.92q-5.49.53-11 1.12a.93.93 0 01-1-.73q-2.13-19.46-4.29-38.92a.94.94 0 01.87-1q8.58-.93 17.17-1.71c10.05-.89 17.1 4 17.67 12a12.6 12.6 0 01-7 11.89q5.71 7.17 11.22 14.4zm-21.15-21.35c2.17-.19 3.53-1.56 3.37-3.45s-1.76-3-3.95-2.8l-3.8.35.6 6.25zM487.36 723.45a.92.92 0 011 .84l1.88 39.11a.89.89 0 01-.9.87q-5.53.27-11.07.6a.91.91 0 01-.92-.77q-1.2-19.54-2.43-39.08a1 1 0 01.86-.94c3.87-.24 7.72-.44 11.58-.63zM541.88 762.43c.19.36-.07.77-.57.77h-12.39a1.48 1.48 0 01-1.33-.76c-.64-2.07-1.28-4.14-1.94-6.2q-5.92.06-11.85.19-.88 3.12-1.75 6.26a1.45 1.45 0 01-1.29.8q-6.19.16-12.39.4c-.5 0-.77-.38-.6-.75q6.3-19.93 13.19-39.77a2.06 2.06 0 011.55-.81q6.68-.15 13.34-.21a2 2 0 011.57.76q7.58 19.6 14.46 39.32zm-22.47-25.85q-1.65 5.65-3.26 11.31c2.29 0 4.59-.08 6.88-.1q-1.8-5.61-3.62-11.21zM574.44 753.35a.81.81 0 01.78.86l-1.26 9a1.05 1.05 0 01-1 .79q-11.28-.47-22.59-.66a.94.94 0 01-.93-.84l.63-39.15a1 1 0 011-.87c3.86.06 7.71.15 11.57.26a1 1 0 01.95.92l-.87 29.31q5.83.13 11.72.38zM598.31 724.37a.92.92 0 01.92 1q-1.32 19.53-2.62 39.06a.89.89 0 01-1 .77q-5.52-.36-11.06-.66a.91.91 0 01-.83-.87q1-19.54 2.07-39.1a.94.94 0 011-.84q5.75.27 11.52.64zM611.75 753.87a.71.71 0 011.17-.38 26 26 0 008.53 3.6c2 .19 3.42-.57 3.56-1.93.34-3.53-17.46-4.88-16.51-17.71.6-7.91 7.6-12.69 17.52-11.77a29.44 29.44 0 0114.11 5.72c.49.36.63.84.4 1.12q-2.49 3.91-5 7.87a.74.74 0 01-1.2.35 26.87 26.87 0 00-8.75-4c-2-.18-3.37.53-3.49 1.82-.3 3.43 17.85 5 16.37 18-.89 7.83-7.87 12.34-17.44 11.45-5.22-.49-10.58-2.48-13.53-5.08-.47-.39-.63-.82-.41-1.1 1.57-2.62 3.11-5.3 4.67-7.96zM685.2 734a.81.81 0 01.77 1q-1.2 4.38-2.38 8.74a1.09 1.09 0 01-1.15.67c-3.17-.5-6.34-1-9.52-1.43q-2.13 14.54-4.24 29.07a.87.87 0 01-1 .7q-5.49-.79-11-1.51a.94.94 0 01-.83-.94q1.9-14.57 3.83-29.13-5.31-.71-10.64-1.33a.89.89 0 01-.8-.93c.36-3 .71-5.93 1.07-8.89a.94.94 0 011-.77q17.52 2 34.89 4.75z"
        />
        <path
          className="prefix__cls-3"
          d="M418.86 725.87a.82.82 0 011 .72q0 4.53.11 9a1.06 1.06 0 01-.93 1q-4.79.57-9.56 1.2 1.92 14.57 3.83 29.13a.86.86 0 01-.76.93q-5.49.74-11 1.51a.93.93 0 01-1.05-.68q-2.11-14.55-4.24-29.08-5.31.76-10.62 1.6a.89.89 0 01-1-.68l-1.41-8.84a.94.94 0 01.76-1q17.4-2.68 34.87-4.81zM468.66 761.25c.35.51-.06 1-.62 1q-6.69.48-13.37 1a1.67 1.67 0 01-1.52-.82q-3.81-6.15-7.72-12.27l-.76.07q.63 6.5 1.25 13a1 1 0 01-.92.92q-5.49.52-11 1.12a1 1 0 01-1-.73q-2.13-19.45-4.29-38.92a1 1 0 01.87-1q8.6-.92 17.19-1.7c10.06-.9 17.12 4 17.69 12a12.59 12.59 0 01-7 11.89q5.7 7.19 11.2 14.44zm-21.17-21.35c2.17-.2 3.54-1.57 3.37-3.46s-1.76-3-3.95-2.79l-3.8.35.6 6.25zM487.31 720.14a.92.92 0 011 .85l1.88 39.1a.9.9 0 01-.9.88q-5.54.27-11.08.6a.92.92 0 01-.92-.77q-1.2-19.54-2.43-39.08a1 1 0 01.86-1l11.59-.58zM541.89 759.13c.19.35-.07.77-.57.76h-12.41a1.48 1.48 0 01-1.32-.76c-.65-2.07-1.29-4.14-2-6.21-3.95.05-7.91.1-11.87.19l-1.72 6.26a1.47 1.47 0 01-1.3.81q-6.19.15-12.4.4c-.5 0-.77-.4-.6-.75q6.31-19.94 13.21-39.77a2.06 2.06 0 011.55-.81q6.68-.15 13.35-.21a2 2 0 011.58.76q7.61 19.61 14.5 39.33zm-22.5-25.85q-1.65 5.65-3.26 11.31l6.88-.11q-1.78-5.61-3.62-11.2zM574.48 750a.84.84 0 01.79.87c-.43 3-.85 6-1.27 9a1 1 0 01-1 .79q-11.3-.46-22.61-.65a.93.93 0 01-.93-.84q.32-19.57.62-39.15a1 1 0 011-.87q5.79.09 11.58.26a.94.94 0 011 .91l-.88 29.31q5.81.17 11.7.37zM598.38 721.07a.92.92 0 01.92.95q-1.32 19.54-2.62 39.07a.91.91 0 01-1 .77q-5.53-.37-11.07-.66a.91.91 0 01-.83-.87q1-19.56 2.07-39.1a1 1 0 011-.84q5.75.3 11.53.68zM611.83 750.57a.72.72 0 011.18-.38 25.89 25.89 0 008.53 3.6c2 .18 3.43-.57 3.56-1.93.35-3.53-17.48-4.89-16.52-17.71.59-7.91 7.61-12.69 17.54-11.77a29.42 29.42 0 0114.12 5.72c.49.35.63.84.4 1.12l-5 7.86a.73.73 0 01-1.2.35 26.77 26.77 0 00-8.76-4c-2-.19-3.37.53-3.49 1.82-.3 3.43 17.87 5 16.39 18-.89 7.83-7.88 12.34-17.46 11.45-5.23-.49-10.59-2.48-13.54-5.08-.47-.4-.63-.83-.42-1.1q2.33-3.96 4.67-7.95zM685.35 730.66a.81.81 0 01.77 1c-.79 2.92-1.59 5.83-2.37 8.74a1.09 1.09 0 01-1.16.67q-4.76-.74-9.53-1.43-2.13 14.53-4.24 29.07a.87.87 0 01-1 .7q-5.49-.78-11-1.51a.93.93 0 01-.82-.94q1.9-14.56 3.83-29.14-5.33-.69-10.65-1.32a.89.89 0 01-.8-.94q.52-4.44 1.07-8.88a.94.94 0 011-.77q17.55 2.09 34.9 4.75z"
        />
        <path
          className="prefix__cls-1"
          d="M542.3 322.78h-.88 2.14zm-91.92 201.64v.08l.06-.09zm-51.23 24.25a3.52 3.52 0 00-.15.42c.75-1.09.78-1.27.15-.42zm264.53 10a14.17 14.17 0 01-3.07.39l12.52 22.64h3.33zm-38.1-50.57v2.14c0-.13 0-.28.05-.41a4.76 4.76 0 00-.05-1.7zm-10.8 16.6c-.09.12-.2.22-.29.33a4.65 4.65 0 00.81-.29zm10.22-5.32c0 .66 0 1.3.08 2l.38.1v-1.86zm-9.21-11.33c-.06.18 0 .41 0 0z"
        />
        <path
          className="prefix__cls-1"
          d="M399 549.09a3.52 3.52 0 01.15-.42c.63-.85.6-.67-.15.42zm51.35-24.59v-.08h.06zm93.71-201.68h-2.67 3.82zM625 519.38c0 .66 0 1.3.08 2l.38.1v-1.86z"
        />
        <path
          className="prefix__cls-1"
          d="M679.64 587.46a9.51 9.51 0 004.37-4 12.6 12.6 0 00.85-1.73h.47c14.83-25.3 16.11-29.87 22.41-58.88a239.58 239.58 0 004.07-26.08c1.82-26.9-18.92-73.33-22.57-82.09a1.25 1.25 0 01.91-1.73 1.26 1.26 0 00.74-2c-5.81-7.65-30.68-39.82-44.87-50.64-.24-.18 4.4-.38 4.15-.55-15.81-12-20-16.71-38.13-22.82 2.16-2.06 3.89-4.54 5.91-6.88 10.16-11.76 6-32.6 4.8-41.92a5.87 5.87 0 00-7.34-4.85c-9.28 2.39-33.54 5.58-43.14 19.49-.48.69-.92 1.4-1.34 2.12-1.94-.43-3.87-.85-5.79-1.24q.09-1.26.09-2.55c0-16.81-14-32.37-20.28-39.44a6 6 0 00-8.9 0c-6.32 7-18.72 23.39-18.74 40.17 0 .64 0 1.32.05 2-2.46.64-4.92 1.33-7.34 2-.46-.76-.94-1.49-1.46-2.23-9.59-13.91-25.37-21.84-34.64-24.24-3.44-.88-6.59 1.14-8.09 4.32-4.64 9.78-5.5 27.65-1.23 43.22a23 23 0 006.08 9.63c-17.44 6.1-23.68 11.7-38.93 23.24-.26.17 6 .37 5.77.55-20.35 15.54-39.87 37.32-50.47 62.58-.12.27 4.66.53 4.54.8l-11.73 46.26a141 141 0 00.17 74.77c.6 2.21 1.27 4.38 2 6.55 2.73 8.32 4 11.55 8.15 19.22l3.91 8.62a19.58 19.58 0 001 2.83c2.17 5.12 9 7.83 14 10l.42.18a13.9 13.9 0 002.12.79L401 612c-11.5 23.32.79 55.63 24.78 63.29 20.6 6.6 73.5 10.73 119.64 8.94 46.15 1.79 99.05-2.34 119.64-8.94 24-7.66 36.29-40 24.79-63.29l-13.42-24.28zm-54-77.6c0 .13 0 .28-.05.41v-2.14a4.76 4.76 0 010 1.73z"
        />
        <path
          className="prefix__cls-1"
          d="M382 551.26a34.3 34.3 0 01-2-6.55c.63 2.21 1.3 4.38 2 6.55zM545.24 322.78h-2.94zM399 549.09a3.52 3.52 0 01.15-.42c.63-.85.6-.67-.15.42zM615.79 508.05c0 .41-.06.18 0 0z"
        />
        <path
          className="prefix__cls-1"
          d="M615.79 508.05c0 .41-.06.18 0 0zM399 549.09a3.52 3.52 0 01.15-.42c.63-.85.6-.67-.15.42zM625.59 509.86c0 .13 0 .28-.05.41v-2.14a4.76 4.76 0 01.05 1.73z"
        />
        <path
          className="prefix__cls-1"
          d="M399 549.09a3.52 3.52 0 01.15-.42c.63-.85.6-.67-.15.42z"
        />
        <path
          d="M615.79 508.05c0 .41-.06.18 0 0z"
          opacity={0.35}
          fill="#edcc43"
        />
        <path
          className="prefix__cls-1"
          d="M399 549.09a3.52 3.52 0 01.15-.42c.63-.85.6-.67-.15.42zM450.44 524.41l-.06.09v-.08zM679.64 587.46l13.71 24.7c11.78 23.81-.82 56.75-25.39 64.58-21.09 6.73-75.29 12.51-122.56 10.7-47.26 1.81-101.46-4-122.55-10.7-24.57-7.83-37.17-40.77-25.39-64.58L409 591.88l.42.18a13.9 13.9 0 002.12.79L401 612c-11.5 23.32.79 55.63 24.78 63.29 20.6 6.6 73.5 10.73 119.64 8.94 46.15 1.79 99.05-2.34 119.64-8.94 24-7.66 36.29-40 24.79-63.29l-13.42-24.28M541.42 322.78h2.93z"
        />
        <path
          d="M676.13 578.86c13.77-23.84 15-28.15 20.8-55.5a229.58 229.58 0 003.78-24.57c1.7-25.36-17.56-69.12-21-77.38a1.19 1.19 0 01.85-1.63 1.19 1.19 0 00.69-1.9c-5.39-7.21-28.49-37.53-41.66-47.73-.23-.17 4.08-.35 3.85-.52A166 166 0 00596 343.8a41.18 41.18 0 005.5-6.49c8.88-13.13 12-30.1 10.85-38.89a5.46 5.46 0 00-6.83-4.57c-8.6 2.25-28.42 8-37.33 21.14-.45.65-.86 1.32-1.25 2-1.8-.41-3.58-.8-5.38-1.17.06-.78.09-1.59.09-2.41.05-15.84-10-29.57-15.87-36.24a5.49 5.49 0 00-8.26 0c-5.88 6.63-16 20.34-16 36.16 0 .61 0 1.25.05 1.85-2.28.61-4.57 1.24-6.82 1.92-.42-.71-.87-1.4-1.35-2.1-8.91-13.12-25-18.89-33.57-21.14a5.47 5.47 0 00-6.84 4.57c-1.14 8.79-1.78 25.76 7.11 38.89a41.09 41.09 0 006.22 7.14 166.37 166.37 0 00-45.64 25.18c-.24.17 5.57.35 5.35.52-18.89 14.64-37 35.18-46.86 59-.11.25 4.32.5 4.22.75l-10.89 43.6a134.85 134.85 0 00.15 70.47c.56 2.09 1.19 4.14 1.86 6.18 2.54 7.85 3.67 10.89 7.57 18.12l4.73 10.6m139.25-244.1l-1.07.05-1.67-.05z"
          fill="url(#prefix__linear-gradient)"
        />
        <path
          d="M394.52 550.14a32.72 32.72 0 01-1.86-6.18c.56 2.09 1.19 4.14 1.86 6.18z"
          fill="url(#prefix__linear-gradient-2)"
        />
        <path
          d="M546.06 334.78l-1.07.05-1.67-.05z"
          fill="url(#prefix__linear-gradient-3)"
        />
        <path
          className="prefix__cls-11"
          d="M410.31 548.1a3.1 3.1 0 01.13-.4c.56-.8.56-.7-.13.4zM616.5 523.56c-.57.29-1.13.58-1.71.85a7.43 7.43 0 01-4.16.73c-.4.45-.81.89-1.19 1.36-2.93 3.73-7 3-9.58.37a8.13 8.13 0 01-7.63-.35q8.13-.71 16.2-1.76c2.7-.35 5.38-.76 8.07-1.2z"
        />
        <path className="prefix__cls-12" d="M611.56 509.41c0 .38-.06.17 0 0z" />
        <path className="prefix__cls-12" d="M611.56 509.41c0 .38-.06.17 0 0z" />
        <path
          className="prefix__cls-11"
          d="M669.55 584.64a8.17 8.17 0 005.34-4.14 21.78 21.78 0 002.18-6.61c1-4.66 1.25-9.53 2.4-14.13 1.08-4.32 3.13-8.39 4.64-12.56a33.87 33.87 0 001.06-21.11 28.41 28.41 0 00-7.59-12.46 56.34 56.34 0 00-3.5-2.36 28.81 28.81 0 00-6.19-2.82c-7-.5-14-.82-21.07.17-9.77 1.37-26.2.86-26.2.86l-.1 15.25s-8.35-.09-8.86.18a6.09 6.09 0 01-3.74.73c-.35.45-.72.89-1.07 1.36-2.62 3.73-6.25 3-8.58.36l-23.9.9c-5.6.3-11.21.48-16.81.62l-32.26-.5c-5.6-.14-11.21-.32-16.81-.62l-23.9-.89c-2.33 2.6-17.76 13.5-20.4 9.78-.35-.47-.71-.91-1.06-1.37a6.08 6.08 0 01-3.74-.72l-1.53-.85.22-16.6-.44-7.63s-13.67-.25-21.6-1.36c-7.09-1-14.07-.67-21.07-.17a28.81 28.81 0 00-6.19 2.82c-1.2.74-2.37 1.54-3.5 2.36a28.38 28.38 0 00-7.59 12.46 33.87 33.87 0 001.06 21.11c1.7 4.74 5.26 9.38 5.57 14.48.35 5.53.11 12.7 2.28 17.87 2.08 5 8.77 7.53 13.36 9.55a10.85 10.85 0 002.68.9c2.92.43 5.61-1.57 7.76-3.59 2.3-2.17 4.51-4.59 5.6-7.55s1-6 .95-9-.36-6.29-2.77-7.91"
        />
        <path
          className="prefix__cls-11"
          d="M410.31 548.1a3.1 3.1 0 01.13-.4c.56-.8.56-.7-.13.4z"
        />
        <path
          d="M663.08 455.84a35.19 35.19 0 012.39 20.38c-2.6 14.36-11.82 22.07-22.77 26a84.68 84.68 0 01-20.7 4.92 1.83 1.83 0 00-1.35 2.27 4.79 4.79 0 010 1.65 54.68 54.68 0 00-.27 13.59c.18 1.88-.63 5.68-2.12 5.56a19.67 19.67 0 01-1.48 1.78c-1.47 0-.69.66-2.68.26-19.23-3.77-26.45-28.49-40.71-41.24-7.61-6.8-24.84-8.74-34.17-9.34-9.32.6-26.55 2.54-34.16 9.34-14.26 12.75-21.48 37.47-40.71 41.24-2 .4-1.21-.26-2.69-.26a19.57 19.57 0 01-1.47-1.78c-1.49.12-2.3-3.68-2.13-5.56a54.2 54.2 0 00-.26-13.59 4.79 4.79 0 010-1.65 1.84 1.84 0 00-1.36-2.27 84.39 84.39 0 01-20.69-4.92c-10.95-4-20.17-11.69-22.77-26a35.19 35.19 0 012.39-20.38c.22-.55.47-1.06.74-1.59h-8.8s6.44-18.9 9.83-25.08c5.14-9.38 14.12-20.8 14.12-20.8h-8.13s15.93-16.92 20.86-22 20.95-18 20.95-18l-7.09-.64s18.46-11.41 38.61-17c13.59-3.77 32.61-4.95 42.56-5h.39c9.93 0 29 1.21 42.56 5 20.13 5.58 38.61 17 38.61 17l-7.1.64s16.12 13 21 18 20.85 22 20.85 22h-8.12s9 11.42 14.13 20.8c3.38 6.18 9.83 25.08 9.83 25.08h-8.8c.24.53.49 1.04.71 1.59z"
          fill="url(#prefix__linear-gradient-4)"
          opacity={0.35}
        />
        <path
          className="prefix__cls-3"
          d="M438.07 469.27c9.22-19.74 23.36-30.4 33.57-29.62 17.11 1.32 15.79 2.64 24.35 34.89 0 0-16.45 11.19-29.62 8.55s-28.3-13.82-28.3-13.82z"
        />
        <rect
          className="prefix__cls-14"
          x={457.23}
          y={443.6}
          width={26.18}
          height={38.17}
          rx={11.65}
        />
        <circle className="prefix__cls-3" cx={467.03} cy={453.47} r={9.87} />
        <path
          className="prefix__cls-3"
          d="M636.87 467.76c-9.21-19.75-23.35-30.41-33.56-29.62-17.12 1.31-15.8 2.63-24.36 34.88 0 0 16.46 11.19 29.62 8.56s28.3-13.82 28.3-13.82z"
        />
        <rect
          className="prefix__cls-14"
          x={591.54}
          y={442.09}
          width={26.18}
          height={38.17}
          rx={11.65}
          transform="rotate(-180 604.625 461.175)"
        />
        <circle className="prefix__cls-3" cx={607.91} cy={451.96} r={9.87} />
        <path
          d="M657.29 667c-19.12 6.22-68.24 10.11-111.08 8.42-42.84 1.69-92-2.2-111.09-8.42-22.27-7.23-33.69-37.67-23-59.65L436.81 562l-12.74-4.5c-9.26-3.37-16-7.16-16-16a16 16 0 0116-16l33.67-.59.3-.09c9.69-2.17 33.72-6.29 37.39-12.8 4.75-8.42 19-23.58 50.78-23.58s46 15.16 50.77 23.58c3.68 6.51 25.31 10.31 35 12.49a6.15 6.15 0 01.81.23l23.77-.92a16 16 0 0111.32 27.32c-2.9 2.9-10.27 6.37-14.69 6.37l27.13 49.85c10.68 21.99-.76 52.43-23.03 59.64z"
          fill="#52535e"
        />
        <path
          d="M655.79 556.7l27.8 50.85C694.51 630 682.81 661 660 668.41c-19.59 6.34-69.91 11.8-113.79 10.08-43.89 1.72-94.21-3.74-113.79-10.08C409.6 661 397.9 630 408.84 607.55L435 560.89l23-36.06.31-.08c9.93-2.22 28.71-12.88 32.48-19.51 4.86-8.59 19.5-24.06 52-24.06s47.14 15.47 52 24.06c3.76 6.63 29.29 17.29 39.21 19.51a8.64 8.64 0 01.83.24z"
          fill="url(#prefix__linear-gradient-5)"
        />
        <path
          d="M542.5 334.78l1.67.05 1.06-.05z"
          fill="url(#prefix__linear-gradient-6)"
        />
        <ellipse
          className="prefix__cls-18"
          cx={519.42}
          cy={643.26}
          rx={11.79}
          ry={7.58}
        />
        <ellipse
          className="prefix__cls-18"
          cx={570.98}
          cy={641.9}
          rx={7.58}
          ry={12.78}
          transform="rotate(-85.98 571.024 641.902)"
        />
        <path
          className="prefix__cls-19"
          d="M579.6 418.66l1.49-11.66c1 .09 36.93 4.65 37.91 4.78 16.25 2.07 14.28 6.56 21.74 14.71zM498.22 418.66L496.73 407c-1 .09-36.92 4.65-37.9 4.78-16.25 2.07-14.28 6.56-21.74 14.71z"
        />
      </g>
    </svg>
  );
};

export default TrialistIcon;
